var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserguide(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.91197V11.8315C15 12.4613 14.454 13.0519 13.782 13.1306L13.551 13.1569C12.025 13.3471 9.67298 14.0754 8.32898 14.7709C8.14698 14.8693 7.84601 14.8693 7.65701 14.7709L7.62898 14.7578C6.28498 14.0689 3.94002 13.3471 2.42102 13.1569L2.21799 13.1306C1.54599 13.0519 1 12.4613 1 11.8315V3.9054C1 3.12461 1.67898 2.53409 2.51198 2.59971C3.98198 2.71125 6.20798 3.40677 7.45398 4.13507L7.62898 4.23346C7.83198 4.35157 8.16802 4.35157 8.37102 4.23346L8.49001 4.1613C8.93101 3.90541 9.491 3.64952 10.1 3.41987V6.09689L11.5 5.22423L12.9 6.09689V2.67191C13.089 2.63911 13.271 2.6194 13.439 2.60628H13.481C14.314 2.54066 15 3.12461 15 3.91197Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.4502V14.2921",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9016 2.67188V6.09685L11.5016 5.22419L10.1016 6.09685V3.41983C11.0186 3.07865 12.0406 2.8031 12.9016 2.67188Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserguide);
export default __webpack_public_path__ + "static/media/User guide.6d3fffb7ba4ef54c3a1507041c363ea6.svg";
export { ForwardRef as ReactComponent };